import { useMemo } from 'react'
import type { FC } from 'react'
import cn from 'classnames'
import { numberToCurrency } from 'helpers/currency'
import parseData from 'helpers/date'
import { Button, Link } from 'components/ui'
import type { OrderItemProps } from '.'
import s from './order-item.module.css'

const OrderItem: FC<OrderItemProps> = ({ className, order }) => {
  const { id, total, createdAt, status } = order
  const created = parseData(createdAt)

  const orderStatus = useMemo(() => {
    switch (status as unknown) {
      default:
      case 'processing':
        return 'Processando o pagamento'

      case 'pending':
        return 'Pendente'

      case 'paid':
        return 'Pago'

      case 'refunded':
        return 'Estornado'

      case 'waiting_payment':
        return 'Aguardando pagamento'

      case 'peding_refund':
        return 'Pagamento estornado'

      case 'refused':
        return 'Pagamento não autorizado'

      case 'chargeback':
        return 'Cobrado novamente'

      case 'analyzing':
        return 'Analisando'

      case 'pending_review':
        return 'Revisão pendente'

      case 'canceled':
        return 'Cancelado'
    }
  }, [status])

  return (
    <div className={cn(s.root, className)}>
      <div className={s.row}>
        <div className={s.label}>Pedido</div>
        <div className={s.value}>
          <Link href={`/pedido/${id}?from=my-orders`}>#{id}</Link>
        </div>
      </div>

      <div className={s.row}>
        <div className={s.label}>Data</div>
        <div className={s.value}>{created}</div>
      </div>

      <div className={s.row}>
        <div className={s.label}>Status</div>
        <div className={s.value}>{orderStatus}</div>
      </div>

      <div className={s.row}>
        <div className={s.label}>Total</div>
        <div className={s.value}>R$ {numberToCurrency(total)}</div>
      </div>

      <div className={s.row}>
        <div className={s.label}>Ações</div>
        <div className={s.value}>
          <Button variant="ghost" href={`/pedido/${id}?from=my-orders`}>
            Visualizar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OrderItem
